import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import styled from 'styled-components'
import {
    Fab,    
    Typography,
    ButtonBase,
    Link,
    TextField,
    InputAdornment,
    Drawer,
    Button,
    Snackbar,
    SnackbarContent,
    TablePagination,
    CircularProgress,
    Tooltip
} from '@material-ui/core'
import {ExpandMore, ErrorOutline} from '@material-ui/icons'
import { IoArrowBackSharp } from 'react-icons/io5'
import {BiSearch} from 'react-icons/bi'
import { VscExpandAll, VscCollapseAll } from 'react-icons/vsc'
import Cookies from 'js-cookie'
import moment from 'moment'
import DayPicker from '../calendar/DayPicker'
import noImage from '../../assets/noImage.png'
import EventRoiDrawer from './EventRoiDrawer'
import EventMarketingMain from './EventMarketingMain'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"
const date_format = "YYYY-MM-DD"

const EventPromoDrawer = (props) => {
    const { closePromotionDrawer, secondaryOpen, openJob, dateExtended, tab, darkMode} = props
    const token = Cookies.get("token")
    const currentUser = JSON.parse(localStorage.getItem("currentUser"))[0] ?  JSON.parse(localStorage.getItem("currentUser"))[0] : {}
    const [eventPromos, setEventPromos] = useState(null)
    const initialStartDate = currentUser ? moment(currentUser.max_date_event).startOf("year").subtract(1, "years") : moment().startOf("year").subtract(1, "years")
    const initialEndDate = currentUser ? moment(currentUser.max_date_event) : moment()    

    const handleClose = () => {
        closePromotionDrawer()
    }
    
    return (
        <div>        
            <div style={{color: `${darkMode ? "#fff" : "#6e6e6e"}`, padding: "1em"}}>
                <Fab size="small" style={{background: "#e04d4a"}} onClick={handleClose}>
                    <IoArrowBackSharp style={{color: "#fff"}}/>
                </Fab>
                <Typography variant="caption" style={{marginLeft: "5px"}}>
                    GO BACK
                </Typography>
            </div>

            <EventMarketingMain
                secondaryOpen={secondaryOpen}
                openJob={openJob}
                dateExtended={dateExtended}
                secondaryTab={tab}
                dark={darkMode}
            />
        </div>
    )
}

export default EventPromoDrawer